function SubscribeFormController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */

	
	/* PRIVATE VARIABLES */
	var submitEnabled = true;
	var form;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function showAlert(message) {
		alert(message);
	}
	
	
	function onFormSendSuccess(){
		$('.state.form', _this.container).hide();
		$('.state.success', _this.container).show();				
		_this.resetForm();
	}	
	
	
	function onFormSendError(){
		showAlert('Nepodařilo se odeslat formulář. Prosíme zkuste to znovu později.');
	}

	
	function initFormHandler(){
		form.validate({
			//focusInvalid: false,
			
			errorPlacement: function(error, element) {
				// none
			},
		   
			invalidHandler: function(f) {
				showAlert('Prosíme vyplňte e-mail.');
			},
			
			submitHandler: function(f) {
				if(submitEnabled){
					submitEnabled = false;

					var data = form.serializeArray();
					data.push({name: "formAction", value: "submit"});
					$.post('/ajax/subscribe.php', data, function(result){
						if(result.status === 1){
							onFormSendSuccess();
						} else {
							onFormSendError();
							submitEnabled = true;
						}
					});
				}
			}
		});
	}
	

	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			form = $('form', _this.container);
		   
			// handlers		
			initFormHandler();
			
			_this.inited = true;
		}
	};
	
	
	this.resetForm = function(){
		form[0].reset();
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
